import { useEffect, useState } from "react";
import {
  getReportLanguage,
  onReportLanguageChange,
  setReportLanguage,
} from "../service/ReportLanguageService";

const useReportLanguage = () => {
  const [language, setLanguage] = useState(getReportLanguage());

  useEffect(() => onReportLanguageChange(setLanguage), []);

  return [language, setReportLanguage];
};

export default useReportLanguage;
